import axios from "axios";
import { useCallback, useEffect, useRef, useState } from "react";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: BASE, withCredentials: true, headers: { "X-Requested-With": "XMLHttpRequest" } });

export const PREVIEW_KEY = "view_as_free";
export const TOKEN_KEY = "session_token";
api.interceptors.request.use((config) => {
  if (localStorage.getItem(PREVIEW_KEY) === "1") config.headers["X-View-As"] = "free";
  const tok = localStorage.getItem(TOKEN_KEY);
  if (tok && !config.headers["Authorization"]) config.headers["Authorization"] = `Bearer ${tok}`;
  return config;
});

export function useGet(path, refreshKey = 0) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const hasData = useRef(false);

  const load = useCallback(async () => {
    if (!path) { setLoading(false); return; }
    if (!hasData.current) setLoading(true);
    try {
      const res = await api.get(path);
      setData(res.data);
      hasData.current = true;
      setError(null);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, [path]);

  useEffect(() => {
    load();
  }, [load, refreshKey]);

  return { data, loading, error, reload: load };
}
